const I = ["row", "column"];
export {
  I as DT_DESCRIPTION_LIST_DIRECTION
};
//# sourceMappingURL=description-list-constants.js.map
